import { STORE_LOCATIONS, STORE_NAMES } from "../config.js";

/**
 * Adds store markers to the map.
 *
 * @param {L.Map} map - The Leaflet map object to which the store markers will be added.
 */
export default function addStores(map) {
  // Go through store locations and get the lat/long coordinates for each store
  STORE_LOCATIONS.forEach((store, index) => {
    const storeName = STORE_NAMES[index];
    let icon;

    if (storeName.includes("Pizza")) {
      icon = "🍕";
    } else if (storeName.includes("20 Spot")) {
      icon = "🍷";
    } else if (storeName.includes("Sushi")) {
      icon = "🍣";
    } else {
      icon = "🍽️";
    }

    const storeIcon = L.divIcon({
      className: "store-marker",
      html: icon,
      iconSize: [40, 40],
    });

    // Create a custom marker, add the popup content (store name and phone number), add to the map
    L.marker([store[0], store[1]], {
      icon: storeIcon,
      autoPan: false,
      closeOnClick: false,
      interactive: true,
      bubblingMouseEvents: false,
    })
      .bindPopup(storeName, {
        closeButton: false,
        disableAnimation: true,
        className: "store-popup",
        interactive: true,
      })
      .addTo(map);
  });
}
